import "@/App.css";
import { Hero } from "./components/landing/Hero";
import { Narrative } from "./components/landing/Narrative";
import { NoCalls } from "./components/landing/NoCalls";
import { Listening } from "./components/landing/Listening";
import { NotScared } from "./components/landing/NotScared";
import { HowItWorks } from "./components/landing/HowItWorks";
import { Transformation } from "./components/landing/Transformation";
import { AboutJ } from "./components/landing/AboutJ";
import { Pricing } from "./components/landing/Pricing";
import { FinalCTA } from "./components/landing/FinalCTA";
import { Footer } from "./components/landing/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-[#FAF3F2] text-[#3B2630]" data-testid="landing-page">
      <Hero />
      <Narrative />
      <NoCalls />
      <Listening />
      <NotScared />
      <HowItWorks />
      <Transformation />
      <AboutJ />
      <Pricing />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default App;
